import { API_BASE_URL } from 'config/api';

const LEAD_ENDPOINT = `${API_BASE_URL.replace(/\/$/, '')}/lead`;
const RETRYABLE_STATUS_MIN = 500;

const wait = (milliseconds) => new Promise((resolve) => setTimeout(resolve, milliseconds));

export class LeadSubmissionError extends Error {
  constructor(message, { status = null, details = null } = {}) {
    super(message);
    this.name = 'LeadSubmissionError';
    this.status = status;
    this.details = details;
  }
}

const readResponse = async (response) => {
  const contentType = response.headers?.get?.('content-type') || '';
  if (!contentType.includes('application/json')) return null;

  try {
    return await response.json();
  } catch (_error) {
    return null;
  }
};

export async function submitLead(payload, { fetchImpl = fetch, retryDelayMs = 250 } = {}) {
  let lastError;

  for (let attempt = 0; attempt < 2; attempt += 1) {
    try {
      const response = await fetchImpl(LEAD_ENDPOINT, {
        method: 'POST',
        credentials: 'omit',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });
      const responseBody = await readResponse(response);

      if (response.ok) return responseBody;

      const error = new LeadSubmissionError('Сервер не принял заявку.', {
        status: response.status,
        details: responseBody,
      });
      if (response.status < RETRYABLE_STATUS_MIN || attempt === 1) throw error;
      lastError = error;
    } catch (error) {
      if (error instanceof LeadSubmissionError && error.status && error.status < RETRYABLE_STATUS_MIN) {
        throw error;
      }
      lastError = error;
      if (attempt === 1) break;
    }

    if (retryDelayMs > 0) await wait(retryDelayMs);
  }

  if (lastError instanceof LeadSubmissionError) throw lastError;
  throw new LeadSubmissionError('Не удалось связаться с сервером. Попробуйте ещё раз.', {
    details: lastError,
  });
}
